// extracted by mini-css-extract-plugin
export default {"img":"avatar_img__ZSDgm"};